export const SEARCH_LOCATIONS = 'SEARCH_LOCATIONS';
export const NEW_LOCATION = 'NEW_LOCATION';
